import script from "./Spinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./Spinner.vue?vue&type=script&lang=ts&setup=true"

import "./Spinner.vue?vue&type=style&index=0&id=2a17fbf5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/posuto/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a17fbf5"]])

export default __exports__